import React from 'react';
import classnames from 'classnames';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'AbsoluteView');
const AbsoluteView = _ref => {
  let {
    className,
    emptyImage,
    title,
    subtitle,
    button
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, className)
  }, emptyImage && /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer
  }, emptyImage), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, title && /*#__PURE__*/React.createElement(Text, {
    type: "subtitleLg",
    bold: true,
    className: classes.title
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    type: "caption",
    className: classes.subtitle
  }, subtitle)), button && /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, button));
};
export default AbsoluteView;